import type { ToastItemProps } from "@/shared/components/ui/Toast";

type ToastShow = (t: ToastItemProps & { durationMs?: number }) => void;

let notifier: ToastShow | null = null;

/** Registered by ToastProvider so non-React modules can show toasts. */
export function registerAppToast(show: ToastShow | null) {
  notifier = show;
}

/** Fallback-safe toast for utilities (e.g. PDF export) outside React hooks. */
export function showAppToast(t: ToastItemProps & { durationMs?: number }) {
  if (notifier) {
    notifier(t);
    return;
  }
  console.warn("[toast]", t.title || t.message);
}
